module.exports = __webpack_public_path__ + "img/Flamingo Esport Logo.jpg";